export enum SystemDatabase {
  ACCOUNT = "account_db",
  ORG = "org_db",
}

export const SYSTEM_DATABASE_NAMES: string[] = [
  SystemDatabase.ACCOUNT,
  SystemDatabase.ORG,
];

export const SYSTEM_SCHEMA_NAMES = ["information_schema"];

export const isSystemDatabase = (databaseName: string) =>
  SYSTEM_DATABASE_NAMES.includes(databaseName as SystemDatabase);
